import makePlainAction from '../../../creators/actions/makePlainAction';

/**
 * Plain action that destroys a set of pending data.
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * dispatch(destroyPendingData({ id: `foobar` }));
 */
const destroyPendingData = makePlainAction({
  model: `pending_data`,
  verb: `destroy`,
});

/** @component */
export default destroyPendingData;
